import Vue from 'vue'
import Router from 'vue-router'
import Cards from '../components/cards'
import Articles from '../components/articles'
import ArtInfo from '../components/artInfo'
import Journal from '../components/journal'
import Notice from '../components/notice'
import NoticeInfo from '../components/noticeInfo'
import Other from '../components/otherArt'
import ShowArt from "../components/showArt";
import Mapss from '../components/qingdaoMap'
import Practitioner from '../components/practitioner'
import ImaNews from '../components/imgNews'
import SearchPage from '../components/searchPage'
Vue.use(Router)

export const constantRoutes=[
    {
        path:'',
        redirect:'/index',

    },
    {
        path:'/index',
        component:Cards
    },
    {
        path:'/imgNews',
        component:ImaNews,
        meta:{title:'图片新闻'}
    },
    {
        path:'/searchPage',
        component:SearchPage,
        meta:{title:'搜索结果'}
    },
    {
        path:'/practitioner/:type',
        component:Practitioner,
        meta:{title:'人员公示'}
    },
    {
        path:'/articles/:id',
        component: Articles,
        meta:{title:'文章内容'}
    } ,
    {
        path:'/artInfo/:id',
        component: ArtInfo,
        meta:{title:'文章内容'}
    } ,
    {
        path:'/notice/noticeInfo/:id',
        component: NoticeInfo,
        meta:{title:'公告内容'}
    } ,
    {
        path:'/qdMap/:type',
        meta:{title:'机构公示'},
        component: Mapss
    } ,
    {
        path:'/other/:id',
        component: Other,
        meta:{title:''}
    } ,
    {
        path:'/showArt/:id',
        component: ShowArt,
        meta:{title:'文章内容'}
    } ,
    {
        path:'/notice',
        component: Notice,
        meta:{title:'通知公告'}
    } ,
    {
        path:'/journal',
        component: Journal,
        meta:{title:'青岛资本市场期刊'}
    },

]

export  default  new Router({
    mode: 'history', // 去掉url中的#
    routes: constantRoutes

})
